import type { Scenario } from "@/domain/entities";
import { builtInScenarios } from "@/domain/scenarios/builtIn";
import type { ScenarioRepository } from "./repositories";

export class BuiltInScenarioRepository implements ScenarioRepository {
  constructor(private readonly scenarios: Scenario[] = builtInScenarios) {}

  async get(id: string): Promise<Scenario | undefined> {
    return this.scenarios.find((s) => s.id === id);
  }

  async list(): Promise<Scenario[]> {
    return [...this.scenarios];
  }
}
